// Wrap fetch to emit public cart events
(function () {

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
        const response = await originalFetch.apply(this, args);

        try {
            const url = typeof args[0] === 'string'
                ? args[0]
                : args[0]?.url;

            const isCartMutation =
                url &&
                (
                    url.includes('/cart/add') ||
                    url.includes('/cart/update') ||
                    url.includes('/cart/change') ||
                    url.includes('/cart/clear')
                );

            const isSuccessful = response.ok;

            // const isOwnGiftRequest = args[1]?.headers?.['X-Lady-A-Gift-Script'] === '1';

            if (isCartMutation && isSuccessful) {
                queueMicrotask(() => {
                    window.dispatchEvent(new CustomEvent('lady-a:cart-mutated'));
                });
            }
        } catch (error) {
            console.warn('Cart listener error', error);
        }

        return response;
    };
})();

// Add / remove wine as appropriate
(function () {
    const LADY_A_RED_VARIANT_ID = 43848507392078;
    const QUALIFYING_PRODUCT_IDS = [
        7903937626190,  // 3
        7903693537358,  // 4
        7903693111374   // 7
    ];

    window.addEventListener('lady-a:cart-mutated', debounce(function () {
        reconcileGiftCart();
    }));

    function debounce(func, timeout = 150){
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }

    function giftHeaders(extra = {}) {
        return {
            'Content-Type': 'application/json',
            'X-Lady-A-Gift-Script': '1',
            ...extra
        };
    }
    
    function cartUrl(path) {
        const root = window.Shopify?.routes?.root || '/';
        return root + path.replace(/^\//, '');
    }

    function goToCartPage() {
        console.log('going to cart page');
        window.location = '/cart';
    }

    async function reconcileGiftCart() {
        if (window.ladyAGiftReconciling) return;
        window.ladyAGiftReconciling = true;

        try {
            const cart = await getCart();
            let haveUpdatedCart = false;

            const hasCampaign =
                sessionStorage.getItem('lady_a_wine_offer') === 'yes'
                || cart.attributes?.['Lady A wine offer'] === 'yes';

            const hasQualifyingBundle = cart.items.some(item =>
                QUALIFYING_PRODUCT_IDS.includes(item.product_id)
            );

            const giftLines = cart.items.filter(item =>
                Number(item.variant_id) === LADY_A_RED_VARIANT_ID
            );
            const giftLinesWithoutPromo = cart.items.filter(item =>
                Number(item.variant_id) === LADY_A_RED_VARIANT_ID && Number(item.final_line_price) !== 0
            );
            
            if (giftLines.length !== 0 && (!hasCampaign || !hasQualifyingBundle)) {
                console.log('removing non-campaign gift');
                await removeGiftLines(giftLines);
                haveUpdatedCart = true;
            }
            
            if (giftLinesWithoutPromo.length !== 0) {
                console.log('removing non-promo gift');
                sessionStorage.setItem('promo_code_inappalicable', 'yes');
                await removeGiftLines(giftLinesWithoutPromo);
                haveUpdatedCart = true;
            }
            
            const customerRemovedGift = sessionStorage.getItem('lady_a_gift_removed_by_customer') === 'yes';
            const promoCodeInapplicable = sessionStorage.getItem('promo_code_inappalicable') === 'yes';
            
            if (!customerRemovedGift && giftLines.length === 0 && hasCampaign && hasQualifyingBundle && !promoCodeInapplicable) {
                console.log('adding gift');
                await addGiftBottle();
                // sessionStorage.removeItem('lady_a_wine_offer');

                // Now gift has been added, check promo code has applied
                const cartAfterGiftAdd = await getCart();
                const newGiftLinesWithoutPromo = cartAfterGiftAdd.items.filter(item =>
                    Number(item.variant_id) === LADY_A_RED_VARIANT_ID && Number(item.final_line_price) !== 0
                );
                if (newGiftLinesWithoutPromo.length !== 0) {
                    console.log('removing new non-promo gift');
                    sessionStorage.setItem('promo_code_inappalicable', 'yes');
                    await removeGiftLines(newGiftLinesWithoutPromo);
                }
                haveUpdatedCart = true;
            }

            if (haveUpdatedCart) {
                goToCartPage();
            }

        } finally {
            window.ladyAGiftReconciling = false;
        }
    }

    async function removeGiftLines(giftLines) {
        if (!Array.isArray(giftLines) || giftLines.length === 0) {
            return;
        }

        for (const line of giftLines) {
            const response = await fetch(cartUrl('/cart/change.js'), {
                method: 'POST',
                headers: giftHeaders(),
                body: JSON.stringify({
                    id: line.key,
                    quantity: 0
                })
            });

            if (!response.ok) {
                const error = await response.json().catch(() => null);
                throw new Error(error?.description || error?.message || 'Could not remove gift line');
            }
        }
    }

    async function addGiftBottle() {
        return fetch(cartUrl('cart/add.js'), {
            method: 'POST',
            headers: giftHeaders(),
            body: JSON.stringify({
                items: [{
                    id: LADY_A_RED_VARIANT_ID,
                    quantity: 1,
                    properties: {
                        _lady_a_gift: 'true'
                    }
                }]
            })
        });
    }

    async function getCart() {
        return fetch('/cart.js').then(res => res.json());
    }
})();